'use strict';

var _ = require('lodash');
var numeral = require('numeral');
var guidRegEx = new RegExp('^[0-9ABCDEF]+$', 'gi');

window.jQuery(function () {
	window.jQuery('[data-toggle="tooltip"]').tooltip();
});

module.exports = {
	calculateSubtotal: function subtotalCalculator() {
		var totalPrice = parseFloat(window.jQuery('#eventFee').val());
		var $subtotal = window.jQuery('#subtotal');
		window.jQuery('#partyMemberSelections select option:checked').each(function eachCheckedOption() {
			var itemPrice = window.jQuery(this).data('price');
			if (typeof itemPrice === 'undefined') {
				// 0
			} else {
				itemPrice = parseFloat(itemPrice);
				totalPrice += itemPrice;
			}
		});
		$subtotal.html('$ ' + numeral(totalPrice).format('9,.99'));
		if (totalPrice > 0) {
			$subtotal.show();
			window.jQuery('#totalrow').show();
		} else {
			$subtotal.hide();
			window.jQuery('#totalrow').hide();
		}
	},
	enableSectionsOptions: function optionEnabler(select) {
		var $this = window.jQuery(select);
		if ($this.val() === 'true' || $this.val().match(guidRegEx) || [].length == 1) {
			$this.closest('.row').find('select').removeAttr('disabled');
		} else {
			var $selects = $this.closest('.row').find('select').not('.primary');
			$selects.find('option').removeAttr('selected');
			$selects.attr('disabled', 'disabled');
		}
	},
	validateActivitySelections: function selectionValidator() {
		var reEnableSubmit = window.jQuery('#partyMemberSelections').data('reenable');
		var error = areThereErrors();
		if (error) {
			window.jQuery('select').on('change', areThereErrors);
			window.alert('Please make a selection in all fields marked in red');
			reEnableSubmit();
		}

		// stuff the ActivityExtra selections into a json field
		var PersonalActivityExtraMeta = {};
		window.jQuery('#partyMemberSelections .activityExtraMeta').each(function() {
			// get activityid, key, and value for each and append
			var activityid = $(this).data('activityid');
			var key = $(this).data('key');
			var value = $(this).val();

			if(PersonalActivityExtraMeta[ activityid ] === undefined) {
			PersonalActivityExtraMeta[ activityid ] = {};
			}
			PersonalActivityExtraMeta[ activityid ][ key ] = value;

		});
		window.jQuery('#activityextrameta').val(JSON.stringify(PersonalActivityExtraMeta));

		return !error;
	}
};

function areThereErrors() {
	var error = false;
	var requiredSelects = window.jQuery('#partyMemberSelections').find('.requireSelection');

	_.map(requiredSelects, function forEachRequiredSelect(el) {
		var $selected = window.jQuery(el);
		var $dependsOn = $selected.closest('.row').find('.primary');
		var selectedVal = $selected.val();
		if (selectedVal === '' && ($dependsOn.val() === 'true' || $dependsOn.val().match(guidRegEx) || [].length == 1)) {
			error = true;
			$selected.closest('div').addClass('error').focus();
		} else if ($selected.is('.primary')) {
			if (selectedVal === '') {
				error = true;
				$selected.closest('div').addClass('error').focus();
			} else {
				$selected.closest('div').removeClass('error');
			}
		} else {
			$selected.closest('div').removeClass('error');
		}
	});

	// activityextra free text responses
	var requiredResponses = window.jQuery('#partyMemberSelections').find('.requireResponse');
	_.map(requiredResponses, function forEachRequiredInput(el) {
		var $input = window.jQuery(el);
		var $dependsOn = $input.closest('.row').find('.primary');
		var inputVal = $input.val();
		if (inputVal === '' && ($dependsOn.val() === 'true' || $dependsOn.val().match(guidRegEx) || [].length == 1)) {
			error = true;
			$input.closest('div').addClass('error').focus();
		} else {
			$input.closest('div').removeClass('error');
		}
	});

	return error;
}
